export default __webpack_public_path__ + "static/media/impact-evidence.613d6218.jpg";